import FaceSmileIcon from '@/assets/images/icons/face-smile.svg?react';
import Icon from './icon';
import type { IconProps } from './icon.type';

const SmileIcon = ({ svgClass, ...props }: IconProps) => {
  return (
    <Icon {...props}>
      <FaceSmileIcon className={svgClass} />
    </Icon>
  );
};

export default SmileIcon;
